import React from "react";

export function GoogleLogoMark({ size = 48 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
      <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
      <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
      <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
    </svg>
  );
}

export function GoogleOAuthHeader() {
  return (
    <div className="google-oauth-header">
      <GoogleLogoMark size={20} />
      <span className="google-oauth-header-text">Sign in with Google</span>
    </div>
  );
}

export function GoogleEmailBadge({ email }) {
  if (!email) return null;
  return (
    <div className="google-email-badge">
      <svg xmlns="http://www.w3.org/2000/svg" className="google-email-badge-icon" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
      </svg>
      <span className="google-email-badge-text">{email}</span>
      <svg xmlns="http://www.w3.org/2000/svg" className="google-email-badge-chevron" viewBox="0 0 24 24" fill="currentColor">
        <path d="M7 10l5 5 5-5z" />
      </svg>
    </div>
  );
}

export function GooglePageFooter() {
  return (
    <footer className="google-page-footer">
      <div className="google-language-selector">
        <select className="google-language-select" defaultValue="en-US">
          <option value="en-US">English (United States)</option>
        </select>
      </div>
      <div className="google-footer-links">
        <a href="#" className="google-footer-link">Help</a>
        <a href="#" className="google-footer-link">Privacy</a>
        <a href="#" className="google-footer-link">Terms</a>
      </div>
    </footer>
  );
}

export default function GoogleAuthLayout({
  heading,
  subheading,
  email,
  showEmailBadge = false,
  brandActions,
  oauthApp = null,
  children,
}) {
  const isOAuth = Boolean(oauthApp);

  return (
    <div className="login-page login-page--google">
      <div className="google-auth-main">
        <div className="google-auth-shell">
          <div
            className={`google-auth-card${showEmailBadge ? " google-auth-card--with-email-badge" : ""}${subheading ? " google-auth-card--with-subheading" : ""}${brandActions ? " google-auth-card--with-brand-actions" : ""}${isOAuth ? " google-auth-card--oauth" : ""}`}
          >
            {isOAuth ? <GoogleOAuthHeader /> : null}
            <main className={`google-auth-body${isOAuth ? " google-auth-body--oauth" : ""}`}>
              <div className="google-auth-brand">
                {isOAuth && !showEmailBadge ? (
                  <div className="google-oauth-app-icon">
                    <img src={oauthApp.iconUrl} alt="" />
                  </div>
                ) : null}
                {!isOAuth ? (
                  <div className="google-logo-container">
                    <GoogleLogoMark />
                  </div>
                ) : null}
                <div className="google-auth-brand-content">
                  <h1 className="google-signin-heading">{heading}</h1>
                  <div className="google-auth-brand-meta">
                    {subheading ? <p className="google-signin-subheading">{subheading}</p> : null}
                    {showEmailBadge || brandActions ? (
                      <div className="google-auth-brand-account">
                        {showEmailBadge ? <GoogleEmailBadge email={email} /> : null}
                        {brandActions ? <div className="google-auth-brand-actions">{brandActions}</div> : null}
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="google-auth-panel">
                <div className="google-auth-panel-stack">{children}</div>
              </div>
            </main>
          </div>
          <GooglePageFooter />
        </div>
      </div>
    </div>
  );
}
